import React from 'react'

const CheckInput = React.forwardRef((props, ref) => (
  <label className='partner-check'>
    <input type='checkbox' {...props} ref={ref} />
    {props.label}
  </label>
))

export default CheckInput
